export default __webpack_public_path__ + "static/media/28_photo.ae1f3dcc.jpeg";